import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'remeda'
import { useMediaQuery } from 'usehooks-ts'
import { Collapsible } from '@velasca/ui/collapsible'
import { SansText } from '@velasca/ui/sans-text'
import { SerifTitle } from '@velasca/ui/serif-title'
import {
  Column,
  ColumnsWrapper,
  ContainerWrap,
  MoreDetailsWrapper,
  StyledReadMore,
} from './styles'

interface MoreDetailsProps {
  title: string
  details: { label: string; text: string }[]
}

const MoreDetails = ({ title, details }: MoreDetailsProps) => {
  const isDesktop = useMediaQuery('(min-width: 992px)')
  const media = useMediaQuery('(min-width: 768px)')
  const { t } = useTranslation('product')

  const firstColumnCut = media ? Math.round(details.length / 2) : 4

  const firstColumn = details.slice(0, firstColumnCut) // Restituisce tutto l'array se indice troppo alto

  const secondColumn = details.slice(firstColumnCut) // Restituisce [] se indice troppo alto

  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <MoreDetailsWrapper id="more-details">
      <SerifTitle
        margin="0 0 2.8rem 0"
        size={isDesktop ? 'md' : 'base'}
        as="h2"
      >
        {title}
      </SerifTitle>
      <ColumnsWrapper>
        <Column>
          {details &&
            firstColumn.map(({ label, text }, index) => {
              return (
                <ContainerWrap key={index} noLastBorder={details.length <= 5}>
                  <SansText
                    as="span"
                    size="md"
                    fontWeight="500"
                  >{`${label}: `}</SansText>
                  <SansText as="span" fontWeight="300" size="md">
                    {text}
                  </SansText>
                </ContainerWrap>
              )
            })}
        </Column>
        <Collapsible
          condition={!media && !isEmpty(secondColumn)}
          height={isExpanded ? 'auto' : 0}
          isExpanded={isExpanded}
        >
          <Column>
            {details &&
              secondColumn.map(({ label, text }, index) => {
                return (
                  <ContainerWrap noLastBorder key={index}>
                    <SansText
                      as="span"
                      fontWeight="500"
                      size="md"
                    >{`${label}: `}</SansText>
                    <SansText as="span" fontWeight="300" size="md">
                      {text}
                    </SansText>
                  </ContainerWrap>
                )
              })}
          </Column>
        </Collapsible>
      </ColumnsWrapper>
      {!media && details && details.length > 5 && (
        <StyledReadMore
          isOpen={isExpanded}
          title={isExpanded ? t('readLess') : t('readMore')}
          onClick={() => {
            setIsExpanded(!isExpanded)
          }}
        />
      )}
    </MoreDetailsWrapper>
  )
}

export default MoreDetails
